module.exports = __webpack_public_path__ + "static/baehrbg-logo-79965dfc25ef4b19ac86928f3e99dfb0.jpg";